/**
 * Section B8 Service - B.8.監測計畫
 * Monitoring Plan
 */
import axios from '../api/axios';

const BASE_URL = '/api/section-b8';

// ── B.7.4 來源參照 ─────────────────────────────────────────────────

export interface B74RefEntry {
  symbol: string;
  para_type: number | null;  // 250=事後監測, null=皆適用
  equation_name: string;
  equation: string;
}

export interface B74AvailableParam {
  symbol: string;
  para_type: number | null;
  unit: string;
  equation_name: string;
  equation: string;
}

export interface B74AvailableParamsResponse {
  available: B74AvailableParam[];
  built: number;
  total: number;
}

// ── B.8.1 參數條目 ─────────────────────────────────────────────────

export interface ParameterRow {
  id: string;
  data_parameter:        string;
  description:           string;
  data_unit:             string;
  equations_referred:    string;
  purpose_baseline:      boolean;
  purpose_project:       boolean;
  purpose_leakage:       boolean;
  measurement_methods:   string | null;
  entity_responsible:    string;
  instrument_type:       string;
  instrument_accuracy:   string;
  instrument_calibration: string | null;
  instrument_location:   string;
  measurement_intervals: string | null;
  qa_qc_procedures:      string | null;
  additional_comment:    string | null;
  b74_ref:               B74RefEntry | null;
}

export interface SectionB8Detail {
  id: number;
  organization_id: number;
  project_id: number;
  parameters:          ParameterRow[] | null;
  sampling_plan:       string | null;
  monitoring_mgmt:     string | null;
  post_crediting_plan: string | null;
  section_b8: number;
  edit_by:    number | null;
  created_at: string | null;
  updated_at: string | null;
  built: number;
  total: number;
}

export type ParameterRowCreate = Omit<ParameterRow, 'id'>;
export type ParameterRowUpdate = Partial<Omit<ParameterRowCreate, 'b74_ref'>>;

export interface SectionB8TextUpdate {
  sampling_plan?:       string | null;
  monitoring_mgmt?:     string | null;
  post_crediting_plan?: string | null;
}

// ── API 函式 ──────────────────────────────────────────────────────

export const getSectionB8ByProject = async (projectId: number): Promise<SectionB8Detail | null> => {
  const res = await axios.get<SectionB8Detail>(`${BASE_URL}/by-project/${projectId}`);
  return res.data;
};

export const getB74AvailableParams = async (projectId: number): Promise<B74AvailableParamsResponse> => {
  const res = await axios.get<B74AvailableParamsResponse>(`${BASE_URL}/${projectId}/b74-available-params`);
  return res.data;
};

export const addParameter = async (projectId: number, entry: ParameterRowCreate): Promise<SectionB8Detail> => {
  const res = await axios.post<SectionB8Detail>(`${BASE_URL}/${projectId}/parameters`, entry);
  return res.data;
};

export const updateParameter = async (
  projectId: number, entryId: string, entry: ParameterRowUpdate
): Promise<SectionB8Detail> => {
  const res = await axios.put<SectionB8Detail>(`${BASE_URL}/${projectId}/parameters/${entryId}`, entry);
  return res.data;
};

export const deleteParameter = async (projectId: number, entryId: string): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}/parameters/${entryId}`);
};

export const updateTextFields = async (projectId: number, body: SectionB8TextUpdate): Promise<SectionB8Detail> => {
  const res = await axios.put<SectionB8Detail>(`${BASE_URL}/${projectId}/text`, body);
  return res.data;
};

export const resetSectionB8 = async (projectId: number): Promise<void> => {
  await axios.post(`${BASE_URL}/${projectId}/reset`);
};

const sectionB8Service = {
  getSectionB8ByProject,
  getB74AvailableParams,
  addParameter,
  updateParameter,
  deleteParameter,
  updateTextFields,
  resetSectionB8,
};
export default sectionB8Service;
